module.exports = __webpack_public_path__ + "static/media/YM10_0.d3a015bd.jpg";